module.exports = __webpack_public_path__ + "assets/icons/edit-24px.svg";